import {
	UserManager,
	UserManagerSettings,
	WebStorageStateStore,
} from 'oidc-client'
import appConfig from '../../app.config'

export function getClientSettings(
	response_mode: string | undefined = undefined,
): UserManagerSettings {
	return {
		authority: appConfig.authorityBaseUrl,
		client_id: 'mypages_ui',
		redirect_uri: `${window.location.origin + '/callback'}`,
		response_type: 'code',
		loadUserInfo: true,
		post_logout_redirect_uri: `${
			window.location.origin + '/logoutcallback'
		}`,
		scope:
			appConfig.system === 'selfServicePortal' && appConfig.environment !== 'production'
				? 'openid tf_bank_creditcard_public_api tf_bank_signing_api'
				: 'openid tf_bank_customer_data_api tf_bank_signing_api',
		automaticSilentRenew: true,
		response_mode,
		clockSkew: 15 * 60, //default 5min
		userStore:
			appConfig.country === 'no'
				? new WebStorageStateStore({ store: window.localStorage })
				: undefined,
	}
}

export function getUserManager() {
	return new UserManager(getClientSettings())
}

export const userManager = getUserManager()
